import { render, staticRenderFns } from "./LegalPersonInput.vue?vue&type=template&id=21306e0c&scoped=true"
import script from "./LegalPersonInput.vue?vue&type=script&lang=js"
export * from "./LegalPersonInput.vue?vue&type=script&lang=js"
import style0 from "./LegalPersonInput.vue?vue&type=style&index=0&id=21306e0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21306e0c",
  null
  
)

export default component.exports